import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="insurance-form"
export default class extends Controller {
  static targets = ["goodsDescription", "policyCost", "premiumCost", "insuranceCost", "goodsValue", "insuranceType", "costWarning", "submitButton", "additionalInsurance"];

  static values = {
    maxInsurance: Number,
  };

  connect() {
    this.updateInsuranceType({ currentTarget: this.insuranceTypeTarget });
    this.updateGoodsValue({ currentTarget: this.goodsValueTarget });
  }

  updateInsuranceType(event) {
    const { options, selectedIndex } = event.currentTarget;
    // This is the default prompt, therefore we don't want to do anything
    if (options[selectedIndex].value == "") return;

    this.goodsDescriptionTarget.value = options[selectedIndex].text;
    this.goodsValueTarget.disabled = event.currentTarget.value == "";
  }

  updateGoodsValue(event) {
    const { value } = event.currentTarget;
    let parsedValue = parseFloat(value);

    if (isNaN(parsedValue)) {
      parsedValue = 0;
    }

    this.costWarningTarget.classList.toggle("invisible", parsedValue < this.maxInsuranceValue);

    if (parsedValue == "" || parsedValue <= 0) {
      this.policyCostTarget.value = "";
      this.premiumCostTarget.value = "";
      this.insuranceCostTarget.value = "";
      this.additionalInsuranceTarget.value = "0";
      this.submitButtonTarget.disabled = true;
      return;
    }

    this.policyCostTarget.value = this.getPolicyCost(event.currentTarget.value);
    this.premiumCostTarget.value = this.getPremiumCost(event.currentTarget.value);
    this.insuranceCostTarget.value = this.getInsuranceCost();
    this.additionalInsuranceTarget.value = "1";
    this.submitButtonTarget.disabled = parsedValue > this.maxInsuranceValue;
  }

  getPolicyCost(value) {
    // TODO: Implement logic to calculate policy cost based on value
    return 12.5;
  }

  getPremiumCost(value) {
    // TODO: Implement logic to calculate premium cost based on value
    return 12.5;
  }

  getInsuranceCost() {
    // TODO: Implement logic to calculate insurance cost based on value
    return parseFloat(this.policyCostTarget.value) + parseFloat(this.premiumCostTarget.value);
  }
}
